export default class Class {
	static get RELATION_TYPE() {
		const RELATION_TYPE = {
			PROJECT: 1,
			MEMBER : 2,
		};

		return RELATION_TYPE;
	}
	
	constructor(params) {
		this.code = params.code;
		this.name = params.name;
		this.relation_code = params.relation_code;
		this.relation_type = params.relation_type;
	}
}
